import React from 'react';
import PropTypes from 'prop-types';
import ConnectedInstitutionRouting from './ConnectedInstitutionRouting';

// TODO: Move to react-viewerbase

function InstitutionManagerRouting({ match }) {
  // TODO: Figure out which filters we want to pass in via a URL
  //const { patientId } = match.params;

  return <ConnectedInstitutionRouting />;
}

InstitutionManagerRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default InstitutionManagerRouting;
